import { render, staticRenderFns } from "./TravStars.vue?vue&type=template&id=c92fe156"
import script from "./TravStars.vue?vue&type=script&setup=true&lang=ts"
export * from "./TravStars.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports